import { useFlags } from 'launchdarkly-react-client-sdk'

import { useGetPublishedCashRoundingQuery } from 'src/apollo/onlineOrdering'

import {
  PaymentOption,
  usePayment
} from 'public/components/online_ordering/PaymentContext'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'

export const useCashRounding = () => {
  const { opopCashRoundingDisclaimer } = useFlags()
  const { paymentOption } = usePayment()
  const { selectedLocation } = useRestaurant()
  const ooClient = useOOClient()

  const { data } = useGetPublishedCashRoundingQuery({
    variables: { restaurantGuid: selectedLocation.externalId },
    client: ooClient,
    skip: !opopCashRoundingDisclaimer || !selectedLocation.externalId
  })

  const cashRoundingEnabled =
    data?.cashRounding?.publishedCashRounding?.enabled === true

  const showDisclaimer =
    opopCashRoundingDisclaimer &&
    cashRoundingEnabled &&
    paymentOption === PaymentOption.UponReceipt

  return { showDisclaimer }
}
